module.exports = __webpack_public_path__ + "static/media/apartment1.367ecd03.jpg";